import { makeStyles, withStyles } from '@material-ui/styles';

const useStyles = propsStyle =>
    makeStyles(theme => ({
        bg: {
            borderRadius: '4px',
            backgroundColor: 'rgb(0,0,185)',
            width: `${propsStyle.avance}%`,
            height: '100%',
            animation: '$loading 1s'
        },

        el: {
            width: '100%',
            height: '100%',
            '&:after': {
                content: `"${propsStyle.avance}%"`,
                display: 'block',
                textAlign: 'right',
                fontSize: '14px',
                fontFamily: theme.typography.fontFamily,
                padding: '5px 5px',
                color: 'rgb(255,255,0)',
                zIndex: '-1',
                mixBlendMode: 'difference'
            }
        },
        wrapper: {
            display: 'flex'
        },
        '@keyframes loading': {
            '0%': {
                width: 0
            },
            '100%': {
                width: `${propsStyle.avance}%`
            }
        }
    }));

const BarraAvance = ({ avance }) => {
    const classes = useStyles({ avance: !avance || avance <= 0 ? 0 : avance > 100 ? 100 : avance })();
    return (
        <div className={classes.wrapper}>
            <div style={{ width: '100%' }}>
                <div className={classes.bg}>
                    <div className={classes.el}></div>
                </div>
            </div>
        </div>
    );
};
export default BarraAvance;
